var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	4983: {
		fallback: () => (() => (__webpack_require__(8485))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	5880: {
		fallback: () => (() => (__webpack_require__(2043))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.9.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-router",

	},
	2839: {
		fallback: () => (() => (__webpack_require__(7552))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	909: {
		fallback: () => (__webpack_require__.e(518).then(() => (() => (__webpack_require__(1518))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@o2/one-reporting-shared-context",

	},
	38: {
		fallback: () => (() => (__webpack_require__(2852))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.30.3",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [4983,5880,2839];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"204": [
		909,
		38
	],
	"792": [
		4983,
		5880,
		2839
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}